import { createFileRoute } from "@tanstack/react-router";
import { guardLaunchRoute } from "@/components/launch/launch-route-guard";
import BudgetsPage from "@/components/launch/budgets/BudgetsPage";

export const Route = createFileRoute("/_authenticated/$orgSlug/launch/budgets")({
  beforeLoad: guardLaunchRoute,
  remountDeps: ({ params }) => params.orgSlug,
  component: LaunchBudgetsPage,
});

function LaunchBudgetsPage() {
  const { orgSlug } = Route.useParams();
  return <BudgetsPage orgSlug={orgSlug} />;
}
